export const TURNSTILE_SITE_KEY = (
	process.env.REACT_APP_TURNSTILE_SITE_KEY || ''
).trim()

/**
 * Captcha off by default until Turnstile is configured end-to-end.
 * Re-enable: set REACT_APP_DISABLE_CAPTCHA=false in frontend .env and restart npm start.
 */
export const CAPTCHA_DISABLED = process.env.REACT_APP_DISABLE_CAPTCHA !== 'false'

export const LOAD_ERROR_MESSAGE =
	'Security verification could not be completed. Please try again.'

export const VERIFY_FAIL_MESSAGE =
	'Verification failed. Please try again.'

export const VERIFY_EXPIRED_MESSAGE =
	'Verification expired. Please try again.'

export const VERIFY_SUCCESS_MESSAGE =
	'Verification successful. You can try again now.'

export const VERIFIED_TTL_MS = 15 * 60 * 1000
export const WARMUP_TIMEOUT_MS = 5000
export const WARMUP_DELAY_MS = 1600
